import React from "react";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";

// Documents & services offered on JaaGa. Each chip links to the right flow
// based on its type: documents open the Property Documents (states) page,
// services open the Property Services page.
const SERVICES = [
  { label: "Property Audit Report", type: "service" },
  { label: "Sale Deed/Certified Copy", type: "doc" },
  { label: "Bhubharati (E.C)", type: "doc" },
  { label: "Pattadhar Passbook", type: "doc" },
  { label: "Adangal / Pahani / ROR-1B", type: "doc" },
  { label: "Prohibited Lands", type: "doc" },
  { label: "Land Market Value", type: "doc" },
  { label: "Tippon Map", type: "doc" },
  { label: "Village/Survey Map", type: "doc" },
  { label: "Land Details Search", type: "doc" },
  { label: "Registered Document Details", type: "doc" },
  { label: "Title Clarity Check", type: "service" },
  { label: "Encumbrance & Mortgage Status", type: "service" },
  { label: "Property Tax & Dues Review", type: "service" },
  { label: "RERA Compliance Check", type: "service" },
  { label: "Document Verification", type: "service" },
  { label: "Expert Legal Insights", type: "service" },
  { label: "Mutation Certificate", type: "doc" },
  { label: "Market Value Report", type: "doc" },
];

const DEST = { doc: "/states", service: "/services" };

const ServicesTicker = () => {
  return (
    <div className="jh-svcticker">
      <span className="jh-svcticker-tag">Documents &amp; Services</span>

      <div className="jh-svcticker-marquee">
        <Marquee speed={40} pauseOnHover gradient={false} loop={0}>
          {SERVICES.map((s, i) => (
            <Link
              key={`${s.label}-${i}`}
              to={DEST[s.type]}
              onClick={() => window.scrollTo(0, 0)}
              className="jh-svcticker-chip"
              aria-label={`${s.label}, open ${
                s.type === "service" ? "Property Services" : "Property Documents"
              }`}
            >
              {s.label}
            </Link>
          ))}
        </Marquee>
      </div>

      <style>{`
        .jh-svcticker {
          display: flex;
          align-items: center;
          width: 100%;
          min-height: 72px;
          background: linear-gradient(90deg, #fbf6ec 0%, #fdf8f0 50%, #fbf6ec 100%);
          overflow: hidden;
          position: relative;
          z-index: 1;
        }
        .jh-svcticker-tag {
          display: inline-flex;
          align-items: center;
          flex-shrink: 0;
          height: 100%;
          padding: 0 22px;
          font-size: 11.5px;
          font-weight: 800;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: var(--jh-navy);
          background: rgba(21, 53, 104, 0.05);
          white-space: nowrap;
        }
        .jh-svcticker-marquee {
          flex: 1;
          min-width: 0;
          overflow: hidden;
        }
        .jh-svcticker-chip {
          display: inline-flex;
          align-items: center;
          height: 42px;
          margin: 0 7px;
          padding: 0 18px;
          border-radius: 999px;
          background: #fdf3e4;
          border: 1px solid #f2dcab;
          color: var(--jh-navy);
          font-size: 14.5px;
          font-weight: 700;
          white-space: nowrap;
          line-height: 1;
          text-decoration: none;
          cursor: pointer;
          transition: transform 0.18s ease, box-shadow 0.18s ease,
            border-color 0.18s ease;
        }
        .jh-svcticker-chip::before {
          content: "";
          width: 9px;
          height: 9px;
          border-radius: 50%;
          background: #ffa900;
          margin-right: 11px;
          flex-shrink: 0;
        }
        .jh-svcticker-chip:hover {
          transform: translateY(-2px);
          border-color: rgba(255, 169, 0, 0.7);
          box-shadow: 0 6px 16px -8px rgba(154, 107, 0, 0.45);
        }
        @media (max-width: 640px) {
          .jh-svcticker-tag { display: none; }
          .jh-svcticker-chip { height: 36px; font-size: 13px; padding: 0 15px; }
        }
      `}</style>
    </div>
  );
};

export default ServicesTicker;
